"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avalanche = exports.Mainnet = exports.Goerli = exports.getXCDeployment = exports.getDeployment = void 0;
const Goerli_json_1 = __importDefault(require("./Goerli.json"));
Object.defineProperty(exports, "Goerli", { enumerable: true, get: function () { return Goerli_json_1.default; } });
const Mainnet_json_1 = __importDefault(require("./Mainnet.json"));
Object.defineProperty(exports, "Mainnet", { enumerable: true, get: function () { return Mainnet_json_1.default; } });
const Avalanche_json_1 = __importDefault(require("./Avalanche.json"));
Object.defineProperty(exports, "Avalanche", { enumerable: true, get: function () { return Avalanche_json_1.default; } });
function getDeployment(chainID) {
    switch (chainID) {
        case 1:
            return Mainnet_json_1.default;
        case 5:
            return Goerli_json_1.default;
        default:
            throw new Error(`No deployment defined for given chainID:${chainID}`);
    }
}
exports.getDeployment = getDeployment;
function getXCDeployment(chainID) {
    switch (chainID) {
        case 43114:
            return Avalanche_json_1.default;
        default:
            throw new Error(`No deployment defined for given chainID:${chainID}`);
    }
}
exports.getXCDeployment = getXCDeployment;
//# sourceMappingURL=index.js.map